/* ==========================================================================

 DeleteFromProjectView

 Author:      Dave Taylor (http://davetayls.me)
 Description: Opens modal to delete a project

 ========================================================================== */
'use strict';

var Backbone = require('backbone'),
  $ = require('jquery'),
  config = require('../../js/config'),
  mediator = require('../../js/mediator'),
  Tooltip = require('../../js/components/Tooltip'),
  PointyModalView = require('../../js/components/PointyModalView'),
  DeleteFromProjectModalView = require('./DeleteFromProjectModalView'),
  DeleteProjectView = Backbone.View.extend({

    initialize: function(options) {
      options = options || {};
      this.projectId = options.projectId;
      this.uri = options.uri;
      this.uriType = options.uriType;

      this.initComponents();
      this.listenTo(this.modalView, DeleteFromProjectModalView.EVENTS.cancelled, this.closeDeleteFromProjectPopup);
      this.listenTo(this.modalView, DeleteFromProjectModalView.EVENTS.succeeded, this.deleteFromProjectSucceeded);
      this.listenTo(this.modalView, DeleteFromProjectModalView.EVENTS.failed, this.openDeleteFromProjectPopup);
    },

    events: {
      click: 'openDeleteFromProjectPopup'
    },

    initComponents: function() {
      this.modalView = new DeleteFromProjectModalView({
        projectId: this.projectId,
        uri: this.uri,
        uriType: this.uriType
      });
      this.modalView.render();
      if (this.$el.is('[title]')) {
        this.tooltip = new Tooltip({
          el: this.el
        });
      }
      this.pointy = new PointyModalView({
        el: this.el,
        offsetX: 4,
        contentCloning: false,
        content: this.modalView.$el,
        multiple: true
      });
    },

    openDeleteFromProjectPopup: function(e) {
      this.pointy.open();
      mediator.on(config.events.ui.resize, this.closeDeleteFromProjectPopup, this);
      if (e) e.preventDefault();
    },

    closeDeleteFromProjectPopup: function() {
      this.pointy.close();
      mediator.off(config.events.ui.resize, this.closeDeleteFromProjectPopup);
    },

    deleteFromProjectSucceeded: function() {
      mediator.trigger(config.events.requestPageReload);
    }

  }, {
    create: function($parent) {
      $parent.find('.js-deleteFromProject').each(function() {
        var $el = $(this);
        new DeleteProjectView({
          el: this,
          projectId: $el.data('project'),
          uri: $el.data('uri'),
          uriType: $el.data('type')
        });
      });
    }
  });

module.exports = DeleteProjectView;



// WEBPACK FOOTER //
// ./assets/components/DesignCenter/DeleteFromProjectView.js